/// <reference types="vite/client" />
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import './localization/i18n';
import { LocalizationProvider } from '@goalsetter/classroom-web-app-sdk/i18n';
import App from './App';
import './styles/globals.css';

const isSentryEnabled =
  import.meta.env.VITE_SENTRY_ENABLED === 'true' ||
  import.meta.env.VITE_SENTRY_ENABLED === '1';

const sentryEnvironment =
  import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE;

if (isSentryEnabled && import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: sentryEnvironment,

    // ❌ NO BrowserTracing
    integrations: [],

    // ❌ NO performance
    tracesSampleRate: 0,

    // ❌ NO replay (opcional, pero recomendado)
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
}

const root = document.getElementById('root')!;
createRoot(root).render(
  <LocalizationProvider>
    <BrowserRouter basename="/auth">
      <App />
    </BrowserRouter>
  </LocalizationProvider>,
);
